import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PolicyAddVehicleUiModule } from '@amfam/policy/add-vehicle/ui';
import { PolicyPipesModule } from '@amfam/policy/pipes';
import { ProfileFeatureModule } from '@amfam/profile/feature';

import { ProfileModule } from '../profile/profile.module';
// application modules
import { SharedModule } from '../shared/shared.module';
import { coverageChangeReducers, policyChangereducers } from './+state';
import { CoverageChangeEffects } from './+state/coverage-change.effects';
import { PolicyChangeEffects } from './+state/policy-change.effects';
import { ContentWrapperComponent } from './components';
import { ChangeRequestAddressFormComponent } from './components/change-request-address-form/change-request-address-form.component';
// components/directives/pipes
import { ChangeRequestDriverLicenseComponent } from './components/change-request-driver-license/change-request-driver-license.component';
import { ChangeRequestFormComponent } from './components/change-request-form/change-request-form.component';
import { ChangeRequestMortgageLenderDetailsComponent } from './components/change-request-mortgage-lender-details/change-request-mortgage-lender-details.component';
import { ChangeRequestNameFormComponent } from './components/change-request-name-form/change-request-name-form.component';
import { ChangeRequestPoliciesComponent } from './components/change-request-policies/change-request-policies.component';
import { ChangeRequestPolicyComponent } from './components/change-request-policy/change-request-policy.component';
import { ChangeRequestVinComponent } from './components/change-request-vin/change-request-vin.component';
import { ChangeRequestConfirmationComponent } from './containers/change-request-confirmation/change-request-confirmation.component';
import { PlchangerequestComponent } from './containers/plchangerequest/plchangerequest.component';
import { CoverageChangeConfirmationComponent } from './coverage-change/coverage-change-confirmation/coverage-change-confirmation.component';
import { CoverageChangeGetQuoteComponent } from './coverage-change/coverage-change-get-quote/coverage-change-get-quote.component';
import { CoverageChangeReviewQuoteComponent } from './coverage-change/coverage-change-review-quote/coverage-change-review-quote.component';
import { CoverageChangeSelectRiskComponent } from './coverage-change/coverage-change-select-risk/coverage-change-select-risk.component';
import { CoverageChangeSendQuoteConfirmationComponent } from './coverage-change/coverage-change-send-quote-confirmation/coverage-change-send-quote-confirmation.component';
import {
  EnrollGoPaperlessComponent,
  GoPaperlessComponent,
  GoPaperlessConfirmationComponent,
  GoPaperlessPolicyListComponent,
  GoPaperlessPromoComponent,
  GoPaperlessSignatureComponent,
  UnenrollGoPaperlessComponent
} from './go-paperless';
import {
  KnowYourDriveComponent,
  KnowYourDriveSignatureComponent,
  KydConfirmationComponent,
  KydNewAddressComponent,
  KydShipToComponent,
  KydShipTosComponent
} from './know-your-drive';
import { KydPartialHouseholdEffects } from './know-your-drive-partial-household/+state/kyd-partial-household.effects';
import * as fromKydPHH from './know-your-drive-partial-household/+state/kyd-partial-household.reducer';
import { AboutKnowYourDriveComponent } from './know-your-drive-partial-household/components/about-kyd/about-know-your-drive.component';
import { KydSmartphoneEnrollAllModalComponent } from './know-your-drive-partial-household/components/kyd-smartphone-enroll-all-modal/kyd-smartphone-enroll-all-modal.component';
import { KydSmartphoneHeaderInfoComponent } from './know-your-drive-partial-household/components/kyd-smartphone-header-info/kyd-smartphone-header-info.component';
import { KydSmartphoneOperatorTableComponent } from './know-your-drive-partial-household/components/kyd-smartphone-operator-table/kyd-smartphone-operator-table.component';
import { KydSmartphonePromoComponent } from './know-your-drive-partial-household/components/kyd-smartphone-promo/kyd-smartphone-promo.component';
import { KydSmartphoneUnenrollAllModalComponent } from './know-your-drive-partial-household/components/kyd-smartphone-unenroll-all-modal/kyd-smartphone-unenroll-all-modal.component';
import { KydSmartphoneUnenrollOneModalComponent } from './know-your-drive-partial-household/components/kyd-smartphone-unenroll-one-modal/kyd-smartphone-unenroll-one-modal.component';
import { NextStepsComponent } from './know-your-drive-partial-household/components/next-steps/next-steps.component';
import { PartialHouseholdUnenrollConfirmationComponent } from './know-your-drive-partial-household/containers/kyd-partial-household-unenroll-confirmation/kyd-partial-household-unenroll-confirmation.component';
import { KydPartialHouseholdComponent } from './know-your-drive-partial-household/containers/kyd-partial-household/kyd-partial-household.component';
import { LifeComponent } from './life';
import { PlautoLargeComponent } from './plauto-large';
import { PlpropertyLargeComponent } from './plproperty-large';
import { PlumbrellaLargeComponent } from './plumbrella-large';
import {
  NoDetailSummaryComponent,
  PolicyListComponent,
  PolicySummaryComponent
} from './policy-list';
import { PolicyResolve } from './policy-replaceVehicle-resolver.service';
import { ProofOfInsuranceComponent } from './proof-of-insurance/proof-of-insurance.component';
import { OnlineBindFailureComponent } from './replace-vehicle/online-bind-failure/online-bind-failure.component';
import { PremiumDetailComponent } from './replace-vehicle/premium-detail/premium-detail.component';
import { PremiumDetailsComponent } from './replace-vehicle/premium-details/premium-details.component';
import { ReplaceVehicleConfirmationComponent } from './replace-vehicle/replace-vehicle-confirmation/replace-vehicle-confirmation.component';
import { ReplaceVehicleGracePeriodComponent } from './replace-vehicle/replace-vehicle-grace-period/replace-vehicle-grace-period.component';
import { ReplaceVehicleReviewComponent } from './replace-vehicle/replace-vehicle-review/replace-vehicle-review.component';
import { ReplaceVehicleRiskSelectionComponent } from './replace-vehicle/replace-vehicle-risk-selection/replace-vehicle-risk-selection.component';
import { ReplaceVehicleComponent } from './replace-vehicle/replace-vehicle.component';
import { UnderwritingQuestionListComponent } from './replace-vehicle/underwriting-question-list/underwriting-question-list.component';
import { UnderwritingQuestionComponent } from './replace-vehicle/underwriting-question/underwriting-question.component';
import { YearMakeModelLookupComponent } from './replace-vehicle/year-make-model-lookup/year-make-model-lookup.component';
import { YearVinLookupComponent } from './replace-vehicle/year-vin-lookup/year-vin-lookup.component';
import {
  AutoCoverageComponent,
  AutoRiskCardComponent,
  LifeRiskCardComponent,
  PropertyRiskCardComponent,
  RiskCardComponent,
  UmbrellaRiskCardComponent
} from './risk-card';
import { CoveragesComponent } from './shared/coverages/coverages.component';
import { DiscountsComponent } from './shared/discounts/discounts.component';
import { PerPersonFirstPipe } from './shared/pipes/per-person.pipe';
import { RiskCountPipe } from './shared/pipes/risk-count.pipe';
import { PolicyDocumentsComponent } from './shared/policy-documents';

@NgModule({
  imports: [
    SharedModule,
    ProfileModule,
    ProfileFeatureModule,
    PolicyPipesModule,
    PolicyAddVehicleUiModule,
    StoreModule.forFeature('policyChange', policyChangereducers),
    StoreModule.forFeature('coverageChange', coverageChangeReducers),
    StoreModule.forFeature('kydPartialHousehold', fromKydPHH.reducer),
    EffectsModule.forFeature([
      PolicyChangeEffects,
      CoverageChangeEffects,
      KydPartialHouseholdEffects
    ]),
    ChangeRequestVinComponent
  ],
  declarations: [
    AutoRiskCardComponent,
    AutoCoverageComponent,
    ChangeRequestConfirmationComponent,
    ChangeRequestFormComponent,
    ChangeRequestPoliciesComponent,
    ChangeRequestPolicyComponent,
    ChangeRequestMortgageLenderDetailsComponent,
    CoveragesComponent,
    DiscountsComponent,
    EnrollGoPaperlessComponent,
    GoPaperlessComponent,
    GoPaperlessConfirmationComponent,
    GoPaperlessPolicyListComponent,
    GoPaperlessPromoComponent,
    GoPaperlessSignatureComponent,
    KnowYourDriveComponent,
    KnowYourDriveSignatureComponent,
    KydConfirmationComponent,
    KydShipToComponent,
    KydShipTosComponent,
    KydNewAddressComponent,
    LifeRiskCardComponent,
    PlautoLargeComponent,
    PlchangerequestComponent,
    PlpropertyLargeComponent,
    PlumbrellaLargeComponent,
    PolicyDocumentsComponent,
    PolicyListComponent,
    PolicySummaryComponent,
    ProofOfInsuranceComponent,
    PropertyRiskCardComponent,
    RiskCardComponent,
    UmbrellaRiskCardComponent,
    UnenrollGoPaperlessComponent,
    ReplaceVehicleComponent,
    ReplaceVehicleReviewComponent,
    ReplaceVehicleConfirmationComponent,
    ReplaceVehicleRiskSelectionComponent,
    ReplaceVehicleGracePeriodComponent,
    YearVinLookupComponent,
    YearMakeModelLookupComponent,
    PremiumDetailsComponent,
    PremiumDetailComponent,
    LifeComponent,
    ChangeRequestNameFormComponent,
    ChangeRequestAddressFormComponent,
    UnderwritingQuestionComponent,
    UnderwritingQuestionListComponent,
    OnlineBindFailureComponent,
    CoverageChangeSelectRiskComponent,
    CoverageChangeGetQuoteComponent,
    CoverageChangeSendQuoteConfirmationComponent,
    CoverageChangeConfirmationComponent,
    CoverageChangeReviewQuoteComponent,
    AboutKnowYourDriveComponent,
    NextStepsComponent,
    KydSmartphoneOperatorTableComponent,
    KydSmartphoneEnrollAllModalComponent,
    KydSmartphoneUnenrollAllModalComponent,
    KydSmartphoneUnenrollOneModalComponent,
    KydSmartphoneHeaderInfoComponent,
    KydPartialHouseholdComponent,
    KydSmartphonePromoComponent,
    PartialHouseholdUnenrollConfirmationComponent,
    NoDetailSummaryComponent,
    ContentWrapperComponent,
    RiskCountPipe,
    PerPersonFirstPipe,
    ChangeRequestDriverLicenseComponent
  ],
  exports: [
    AutoRiskCardComponent,
    AutoCoverageComponent,
    ChangeRequestConfirmationComponent,
    ChangeRequestFormComponent,
    ChangeRequestPoliciesComponent,
    ChangeRequestPolicyComponent,
    ChangeRequestMortgageLenderDetailsComponent,
    CoveragesComponent,
    DiscountsComponent,
    EnrollGoPaperlessComponent,
    GoPaperlessComponent,
    GoPaperlessConfirmationComponent,
    GoPaperlessPolicyListComponent,
    GoPaperlessPromoComponent,
    GoPaperlessSignatureComponent,
    KnowYourDriveComponent,
    KnowYourDriveSignatureComponent,
    KydConfirmationComponent,
    KydShipToComponent,
    KydShipTosComponent,
    KydNewAddressComponent,
    KydSmartphoneHeaderInfoComponent,
    AboutKnowYourDriveComponent,
    NextStepsComponent,
    LifeRiskCardComponent,
    PlautoLargeComponent,
    PlchangerequestComponent,
    PlpropertyLargeComponent,
    PlumbrellaLargeComponent,
    PolicyDocumentsComponent,
    PolicyListComponent,
    PolicySummaryComponent,
    ProofOfInsuranceComponent,
    PropertyRiskCardComponent,
    RiskCardComponent,
    UmbrellaRiskCardComponent,
    UnenrollGoPaperlessComponent,
    KydSmartphoneOperatorTableComponent,
    PremiumDetailComponent,
    NoDetailSummaryComponent,
    ContentWrapperComponent,
    RiskCountPipe,
    ChangeRequestDriverLicenseComponent
  ],
  providers: [PolicyResolve]
})
export class PolicyModule {
  constructor(@Optional() @SkipSelf() parentModule: PolicyModule) {
    if (parentModule) {
      throw new Error('PolicyModule is already loaded. Lazy load only');
    }
  }
}
